<template>
  <div id="store-selector">
    <call />
    <pop-alert />
    <!-- main -->
    <main style="padding-bottom: 16px">
      <div class="l-login__logo">
        <div class="l-login__logo--img">
          <img src="/assets/images/logo/icon-aeon-town.svg" alt="">
        </div>
        <div class="l-login__logo--text font-bold font-size-18">
          店舗選択
        </div>
        <img src="/assets/images/icon/icon-map-active.svg" class="mt-32" width="34" alt="" />
      </div>
      <div class="selectstore-note">
        お客様のご利用される店舗を <br/>
        選択してください。
      </div>
      <div class="area-list-select mt-32">
        <div v-for="(area_name, area_id) in AREA_DEF" class="btn-select" @click="scrollToArea(area_id)" :key="area_id">
          {{area_name}}
        </div>
      </div>
      <template v-for="(area_name, area_id) in AREA_DEF">
        <section class="area" v-if="area_id in sortedShops" :key="area_id" :id="'area-' + area_id">
          <h2>{{area_name}}</h2>
          <div class="store-selector__shops">
            <shop-button v-for="(shop, index) in shops[area_id]" :key="index" :shop_data="shop" :show_favorite="false" :onselect="onSelectShop" :onaccess="onAccessShop" />
          </div>
        </section>
      </template>
      <store-select-alert :shop="selectedShop" :isChange="false" :show="showSelectAlert" :onclose="onCloseModal" :isFristTime="true" />
    </main>
    <div class="layer" :class="{ fade: false }"></div>
    <div class="screen-loader loader--style1" :class="{ fade: false }" title="0">
      <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
        <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
        <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
      </svg>
    </div>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Tenant } from "../plugin/mixin.js";
import { Common } from "../common/common.js";
import PopAlert from "../components/PopAlert.vue";
import ShopButton from "../components/ShopButton.vue";
import StoreSelectAlert from "../components/StoreSelectAlert.vue";
import { getShops } from "../store/firestore";
import { AREA_DEF } from "../config/const";
import store from "../store";

export default Vue.extend({
  name: "StoreSelect",
  components: {
    PopAlert,
    ShopButton,
    StoreSelectAlert
  },
  mixins: [Tenant],
  mounted() {
    Common.initDom();
  },
  data() {
    return {
      AREA_DEF: AREA_DEF,
      shops: {},
      selectedShop: null,
      showSelectAlert: false
    }
  },
  computed: {
    sortedShops() {
      return this.sortCities(this.shops);
    }
  },
  async created() {
    Common.loadingShow();
    if (store.state.shopId) {
      this.$router.push('/top');
    }
    this.shops = await getShops();
    Common.loadingHide();
  },
  methods: {
    onSelectShop(shopData) {
      this.selectedShop = shopData;
      this.showSelectAlert = true;
    },
    onAccessShop(shopData) {
      this.$router.push(`/location/${shopData.id}`)
    },
    onCloseModal() {
      this.showSelectAlert = false;
    },
    scrollToArea(currentArea) {
      this.currentArea = currentArea
      this.$nextTick(() => {
        const el = document.getElementById(`area-${currentArea}`);
        if (el) {
          window.scrollTo({ top: el.offsetTop, behavior: 'smooth' });
        }
      });
    }
  }
});
</script>